import React from 'react';
import { useTheme } from '@material-ui/core';

interface LoyaltyIconProps {
  className?: string;
}

const LoyaltyIcon = ({ className }: LoyaltyIconProps) => {
  const {
    common: { white },
    icon: { loyalty },
  } = useTheme<any>().palette;

  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g filter="url(#filter0_d_796_1226)">
        <path
          d="M4.7944 19.421C2.7203 16.0154 2.3558 12.2114 4.16649 8.49171C4.65511 7.48699 5.28975 6.79979 6.05413 5.99223C6.97633 5.01903 7.77497 4.23325 8.94259 3.58617C11.5963 2.11491 15.5839 2.05243 18.1224 2.54362C31.6746 5.16518 29.0394 29.1232 14.7768 25.9852C12.1371 25.4046 10.1945 24.1747 7.92885 22.6919C6.56802 21.7984 5.63909 20.8074 4.7944 19.421Z"
          fill={loyalty}
        />
      </g>
      <g filter="url(#filter1_d_796_1226)">
        <path
          d="M12.4478 16.924C13.1207 16.8347 13.7426 16.8876 14.3542 16.8496C14.6393 16.8362 14.9249 16.852 15.2068 16.8965C15.3414 16.9136 15.5026 16.9531 15.615 16.9159C15.7755 16.863 15.9922 16.4099 15.9108 16.2417C15.0123 15.6635 13.9963 15.3012 12.961 15.0452C12.7392 14.9909 12.5373 14.9805 12.2733 14.9321C12.0217 14.8978 11.7684 14.8771 11.5146 14.8703C11.4366 14.8746 11.3588 14.8593 11.2883 14.8257C11.1899 14.7513 11.2757 14.6367 11.3349 14.5489C11.7327 13.9648 12.0233 13.3509 12.4167 12.807C12.751 12.3449 13.1829 11.7943 13.4298 11.3032C13.7256 10.7183 14.0577 10.2934 14.4156 9.81497C14.5849 9.59175 14.7949 9.33429 14.8918 9.16315C15.076 8.83433 15.2859 8.52082 15.5196 8.22559C15.6527 8.05743 15.8369 7.92795 15.8413 7.69059C15.5781 7.47703 15.2734 7.0209 14.9147 7.12136C14.34 7.25392 13.748 7.29435 13.1607 7.24116C13.0231 7.23148 12.8834 7.19353 12.7466 7.17419C12.6098 7.15484 12.4752 7.12582 12.3413 7.09978C12.0285 7.03058 11.6625 6.97551 11.3378 6.8959C10.7352 6.74708 10.0807 6.74708 9.46175 6.80065C8.8428 6.85423 7.81787 7.22999 7.62561 7.83271C7.53687 8.11174 7.3239 8.40268 7.45331 8.73529C8.15052 8.81177 8.85136 8.85002 9.55271 8.84988C10.1761 8.89825 10.7315 8.76431 11.3667 8.8923C11.5967 8.93918 12.0108 8.85286 12.2304 8.98382C11.7793 9.62587 11.294 10.2429 10.7766 10.8321C10.4477 11.201 10.1485 11.5957 9.88178 12.0123C9.61245 12.4137 9.30912 12.7908 8.97517 13.1396C8.26526 13.9514 7.43926 15.0073 7.21593 15.3086C6.97782 15.6308 6.63395 16.0363 6.52525 16.3243C6.44021 16.5475 6.57997 16.8526 6.78777 16.9568C6.88316 17.1235 7.04437 17.2351 7.18487 17.3571C7.71878 17.6391 8.25565 17.6547 8.82506 17.555C8.96556 17.5307 9.1068 17.5059 9.24878 17.4806C10.0955 17.3169 10.9836 17.2254 11.7934 17.0156C12.0095 16.9726 12.2281 16.9428 12.4478 16.9263"
          fill={white}
        />
        <path
          d="M20.5196 20.7817C21.1925 20.6924 21.8143 20.7452 22.4257 20.7073C22.7108 20.6939 22.9964 20.7096 23.2782 20.7542C23.4128 20.7713 23.574 20.8107 23.6864 20.7735C23.8468 20.7207 24.0634 20.2677 23.9821 20.0996C23.0838 19.5216 22.0679 19.1594 21.0328 18.9035C20.811 18.8492 20.6091 18.8388 20.3451 18.7904C20.0936 18.7561 19.8403 18.7355 19.5866 18.7287C19.5086 18.7329 19.4309 18.7176 19.3603 18.6841C19.262 18.6097 19.3477 18.4951 19.4069 18.4074C19.8047 17.8235 20.0952 17.2098 20.4886 16.666C20.8228 16.2041 21.2546 15.6537 21.5015 15.1627C21.7973 14.5781 22.1293 14.1534 22.4871 13.6751C22.6564 13.4519 22.8664 13.1945 22.9633 13.0235C23.1476 12.6947 23.3578 12.3813 23.5917 12.0862C23.7248 11.9181 23.9089 11.7887 23.9141 11.5514C23.6501 11.3379 23.3455 10.882 22.9869 10.9824C22.4122 11.1149 21.8204 11.1553 21.2331 11.1021C21.0956 11.0925 20.9566 11.0545 20.8191 11.0352C20.6816 11.0158 20.5477 10.9868 20.4139 10.9571C20.1012 10.8879 19.7352 10.8329 19.4106 10.7533C18.808 10.6045 18.1537 10.6045 17.5348 10.6581C16.9159 10.7116 15.889 11.0925 15.6967 11.6935C15.608 11.9724 15.3951 12.2633 15.5244 12.5958C16.2216 12.6722 16.9223 12.7105 17.6235 12.7103C18.2468 12.7587 18.8021 12.6248 19.4372 12.7527C19.6671 12.7996 20.0812 12.7133 20.3008 12.8442C19.8497 13.486 19.3645 14.1028 18.8472 14.6919C18.5184 15.0607 18.2192 15.4551 17.9525 15.8716C17.6833 16.2729 17.38 16.6499 17.0461 16.9985C16.337 17.8101 15.5104 18.8656 15.2871 19.1668C15.049 19.4889 14.706 19.8943 14.5965 20.1822C14.5115 20.4053 14.6512 20.7103 14.859 20.8144C14.9544 20.981 15.1156 21.0926 15.2561 21.2146C15.7899 21.4965 16.3267 21.5121 16.896 21.4125C17.0365 21.3882 17.1777 21.3634 17.3196 21.3381C18.1662 21.1744 19.0542 21.083 19.8638 20.8732C20.08 20.8303 20.2985 20.8005 20.5182 20.7839"
          fill={white}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_796_1226"
          x="0.617143"
          y="0.679434"
          width="28.7657"
          height="28.7657"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.794286" />
          <feGaussianBlur stdDeviation="1.19143" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_796_1226" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_796_1226"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_796_1226"
          x="6.49994"
          y="6.76801"
          width="17.4999"
          height="15.0974"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.397143" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.675 0 0 0 0 0.248046 0 0 0 0 0.106875 0 0 0 1 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_796_1226" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_796_1226"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default LoyaltyIcon;
